import React from "react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import "./CustomDataTable.css";

interface CustomDataTableProps {
  rows: any;
  columns: GridColDef[];
  initialState?: {
    pagination: {
      paginationModel: {
        page: number;
        pageSize: number;
      };
    };
  };
  pageSizeOptions?: number[];
  checkboxSelection?: boolean;
  onRowClick?: (row: any) => void;
  getRowId: any;
  onPaginationModelChange?: (model: { page: number; pageSize: number }) => void;
  rowCount?: number;
  paginationMode?: "client" | "server";
}

const CustomDataTable: React.FC<CustomDataTableProps> = ({
  rows,
  columns,
  initialState = {
    pagination: {
      paginationModel: { page: 0, pageSize: 5 }
    }
  },
  pageSizeOptions = [5, 10],
  checkboxSelection = false,
  onRowClick = (val: any) => {},
  getRowId,
  onPaginationModelChange,
  rowCount,
  paginationMode = "client"
}) => {
  return (
    <div style={{ width: "100%" }}>
      <style>
        {`
          .MuiDataGrid-root .MuiDataGrid-main .MuiDataGrid-row,
          .MuiDataGrid-root .MuiDataGrid-main .MuiDataGrid-row[data-mui-rowindex]:hover,
          .MuiDataGrid-root .MuiDataGrid-main .MuiDataGrid-row.Mui-selected,
          .MuiDataGrid-root .MuiDataGrid-main .MuiDataGrid-row[data-mui-rowindex]:hover.Mui-selected,
          .MuiDataGrid-root .MuiDataGrid-main .MuiDataGrid-row.Mui-selected:focus,
          .MuiDataGrid-root {
            border: none;
          }
        `}
      </style>
      <DataGrid
        rows={rows}
        getRowId={(row: any) => row[getRowId]}
        columns={columns}
        initialState={initialState}
        pageSizeOptions={pageSizeOptions}
        checkboxSelection={checkboxSelection}
        onRowClick={onRowClick}
        onPaginationModelChange={onPaginationModelChange}
        rowCount={rowCount}
        paginationMode={paginationMode}
      />
    </div>
  );
};

export default CustomDataTable;
